/* eslint-disable react-hooks/exhaustive-deps */
import "@fortawesome/fontawesome-free/css/all.min.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import "./assets/app.css";
import ArchiveDialog from "./components/PublicDialogs/ArchiveDialog";
import MsgDialog from "./components/PublicDialogs/MsgDialog";
import ApiLayout from "./layout/ApiLayout";
import AppRoutes from "./routes/index";
import * as app from "./services/AppService";
import { reload } from "./store/auth";
import Spinner from "./utils/Spinner";
import { MobileMode } from "./components/MobileMode";
import { isNotChromeMobile } from "./core/utils/is";

const ArStyle = React.lazy(() => import("./utils/RtlTheme"));
const EnStyle = React.lazy(() => import("./utils/LtrTheme"));

export default function App() {
    let navigate = useNavigate();
    const store: any = useSelector((store) => store);
    const path = useLocation().pathname;

    const [state, setState] = useState({
        loading: true,
        OnlyAPI: false,
        options: { winStyle: "bestrate", companyName: "" },
    });

    let IsAr = app.getCookie("language", "en") === "ar";

    useEffect(() => {
        if (path === "/Signin" && [0, 1].includes(store.loginState.userType))
            navigate("/UserDashboard");
        if (path === "/Signin" && +store.loginState.userType === 2)
            navigate("/AgentDashboard");
    }, [path]);

    const dispatch = useDispatch();
    useEffect(() => {
        let IsLogout = ["/TrackShipping", "/OurAgents", "/TrackTransfer", "/style", "/"].includes(window.location.pathname);

        dispatch(
            reload((res: any) => {
                if (!res.IsLoged && !IsLogout) navigate("/Signin");
                setState({
                    loading: false,
                    OnlyAPI: res.OnlyAPI,
                    options: res.IsLoged ? res.User.Options : res.Options,
                });
            }, IsLogout) as any
        );
        try {
            if (Notification && Notification.permission !== "granted")
                Notification.requestPermission();
        } catch (e) { }
        if (app.getCookie("colorMode", "empty") === "empty")
            app.setCookie("colorMode", "auto", 365);
        if (app.getCookie("language", "empty") === "empty")
            app.setCookie("language", "ar", 365);
    }, []);

    const lang = app.translate("Lang") === "ar" ? "rtl" : "ltr";
    const mode = app.getCookie("colorMode", window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");

    document.body.setAttribute("data-bs-theme", mode);

    return state.loading ?
        <Spinner Loading />
        : state.OnlyAPI ?
            <ApiLayout />
            : <>
                {isNotChromeMobile() ?
                    <MobileMode></MobileMode>
                    :
                    <div className={lang} data-bs-theme={mode}
                        style={{ direction: app.translate("Lang") === "ar" ? "rtl" : "ltr" }}>

                        <title>{state.options.companyName}</title>
                        <React.Suspense fallback={<Spinner Loading />}>
                            {IsAr && <ArStyle Style={state.options.winStyle} />}
                            {!IsAr && <EnStyle Style={state.options.winStyle} />}
                        </React.Suspense>
                        <Spinner Loading={store.showSpinner} />
                        <MsgDialog {...store.msgDialog} />
                        <ArchiveDialog {...store.archiveDialog} />
                        <AppRoutes />
                    </div>
                }
            </>
}